<h2 id="labelref">Welcome to the Law Society of Alberta’s Continuing Professional Development Tool</h2>
<p class="description">In accordance with <a rel="noopener" target="_blank" href="https://documents.lawsociety.ab.ca/wp-content/uploads/2017/01/04144612/Rules.pdf#page=32">The Rules of the Law Society of Alberta (opens new window)</a>, Rule 42, please confirm that your profile
    information is up to date.</p>
<div class="profile-box" *ngIf="profile">
    <div class="profile-box-container">
        <div class="item">
            <mat-form-field appearance="fill">
                <mat-label>First Name</mat-label>
                <input aria-label="First Name" matInput readonly="true" [value]="profile.member?.given_nm">
            </mat-form-field>
        </div>
        <div class="item">
            <mat-form-field appearance="fill">
                <mat-label>Last Name</mat-label>
                <input aria-label="Last Name" matInput readonly="true" [value]="profile.member?.last_nm">
            </mat-form-field>
        </div>
        <div class="item">
            <mat-form-field appearance="fill">
                <mat-label>Name of Organization</mat-label>
                <input aria-label="Name of Organization" matInput readonly="true"
                    [value]="profile.primary_location?.company_nm">
            </mat-form-field>
        </div>
        <div class="item">
            <mat-form-field appearance="fill">
                <mat-label>Preferred Email Address</mat-label>
                <input aria-label="Preferred Email Address" matInput readonly="true" [value]="profile.member?.email_no">
            </mat-form-field>
        </div>
        <div class="item">
            <mat-form-field appearance="fill">
                <mat-label>Location</mat-label>
                <input aria-label="Location" matInput readonly="true" [value]="profile.primary_location?.city_nm">
            </mat-form-field>
        </div>
        <div class="item">

        </div>
        <div class="item">
            <h3 id="pa-desc">Practice Areas</h3>
            <ul class="practice-area" aria-describedby="pa-desc">
                <li *ngFor="let area of practiceAreas?.memberAOP">{{area.practice_area?.area_class}}</li>
            </ul>
        </div>
    </div>
    <div class="clearfix"></div>
</div>
<div class="bottom-wrapper">
<p id="button-desc">If any of the above information is incorrect or your personal contact information has changed, you will need to close the CPD Tool and edit your information in the Lawyer Portal. <button class="link-return" (click)="return()">Close the CPD Tool and open the Lawyer Portal</button></p>
<div class="button-wrap"><button aria-labelledby="button-desc" mat-dialog-close="ok" class="ok-button" type=button mat-raised-button color="primary">OK</button></div>
</div>